<template>
  <div class="mfi-oversold-view">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h1>指标筛选</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">基于MFI、RSI、MACD、KDJ、布林线五指标的综合筛选系统</p>
    </div>

    <div class="filter-bar">
      <!-- MFI指标 -->
      <div class="filter-group">
        <span class="filter-label">MFI</span>
        <el-select
          v-model="mfiRange"
          placeholder="区间"
          clearable
          class="filter-select"
        >
          <el-option label="超卖区 (&lt;20)" value="oversold"></el-option>
          <el-option label="超买区 (&gt;80)" value="overbought"></el-option>
          <el-option label="正常区 (20-80)" value="normal"></el-option>
        </el-select>
        <el-select
          v-model="mfiMa5Compare"
          placeholder="MA5比较"
          clearable
          class="filter-select"
        >
          <el-option label="高于MA5" value="above"></el-option>
          <el-option label="低于MA5" value="below"></el-option>
        </el-select>
      </div>

      <!-- RSI指标 -->
      <div class="filter-group">
        <span class="filter-label">RSI</span>
        <el-select
          v-model="rsiRange"
          placeholder="区间"
          clearable
          class="filter-select"
        >
          <el-option label="超卖区 (&lt;30)" value="oversold"></el-option>
          <el-option label="超买区 (&gt;70)" value="overbought"></el-option>
          <el-option label="正常区 (30-70)" value="normal"></el-option>
        </el-select>
      </div>

      <!-- MACD指标 -->
      <div class="filter-group">
        <span class="filter-label">MACD</span>
        <el-select
          v-model="macdSignal"
          placeholder="信号"
          clearable
          class="filter-select"
        >
          <el-option label="金叉" value="golden_cross"></el-option>
          <el-option label="死叉" value="death_cross"></el-option>
        </el-select>
      </div>

      <!-- KDJ指标 -->
      <div class="filter-group">
        <span class="filter-label">KDJ</span>
        <el-select
          v-model="kdjRange"
          placeholder="区间"
          clearable
          class="filter-select"
        >
          <el-option label="超卖区 (&lt;20)" value="oversold"></el-option>
          <el-option label="超买区 (&gt;80)" value="overbought"></el-option>
          <el-option label="正常区 (20-80)" value="normal"></el-option>
        </el-select>
        <el-select
          v-model="kdjSignal"
          placeholder="信号"
          clearable
          class="filter-select"
        >
          <el-option label="金叉" value="golden_cross"></el-option>
          <el-option label="死叉" value="death_cross"></el-option>
        </el-select>
      </div>

      <!-- 布林线指标 -->
      <div class="filter-group">
        <span class="filter-label">布林线</span>
        <el-select
          v-model="bollingerPosition"
          placeholder="位置"
          clearable
          class="filter-select"
        >
          <el-option label="突破上轨" value="upper"></el-option>
          <el-option label="跌破下轨" value="lower"></el-option>
          <el-option label="突破中轨" value="mid"></el-option>
        </el-select>
        <el-select
          v-model="bollingerWidth"
          placeholder="带宽"
          clearable
          class="filter-select"
        >
          <el-option label="窄幅 (&lt;5%)" value="narrow"></el-option>
          <el-option label="正常 (5%-10%)" value="normal"></el-option>
          <el-option label="扩张 (10%-20%)" value="expanding"></el-option>
          <el-option label="宽幅 (&gt;20%)" value="wide"></el-option>
        </el-select>
      </div>

      <!-- 价格比值 -->
      <div class="filter-group">
        <span class="filter-label">Max/Min比</span>
        <el-input-number
          v-model="highLowRatioMin"
          :min="1"
          :max="10"
          :step="0.1"
          :precision="2"
          controls-position="right"
          placeholder="最小"
          class="small-input"
        ></el-input-number>
        <span class="range-separator">-</span>
        <el-input-number
          v-model="highLowRatioMax"
          :min="1"
          :max="10"
          :step="0.1"
          :precision="2"
          controls-position="right"
          placeholder="最大"
          class="small-input"
        ></el-input-number>
        <el-input-number
          v-model="highLowWindow"
          :min="10"
          :max="1000"
          :step="10"
          controls-position="right"
          class="small-input"
        ></el-input-number>
      </div>

      <div class="filter-group">
        <span class="filter-label">Cur/Min比</span>
        <el-input-number
          v-model="closeMinRatioMin"
          :min="1"
          :max="10"
          :step="0.1"
          :precision="2"
          controls-position="right"
          placeholder="最小"
          class="small-input"
        ></el-input-number>
        <span class="range-separator">-</span>
        <el-input-number
          v-model="closeMinRatioMax"
          :min="1"
          :max="10"
          :step="0.1"
          :precision="2"
          controls-position="right"
          placeholder="最大"
          class="small-input"
        ></el-input-number>
        <el-input-number
          v-model="closeMinWindow"
          :min="10"
          :max="1000"
          :step="10"
          controls-position="right"
          class="small-input"
        ></el-input-number>
      </div>

      <!-- 返回数量 -->
      <div class="filter-group">
        <span class="filter-label">数量</span>
        <el-input-number
        v-model="limit"
        :min="50"
        :max="500"
        :step="50"
        placeholder="返回数量"
        class="limit-input"
      ></el-input-number>
      </div>

      <el-button type="primary" @click="fetchData" :loading="loading">
        <i class="el-icon-search"></i>
        筛选
      </el-button>
      <el-button @click="resetFilters">
        <i class="el-icon-refresh-left"></i>
        重置
      </el-button>
    </div>

    <div v-if="stockList.length > 0" class="result-section">
      <div class="result-count">找到 <strong>{{ stockList.length }}</strong> 只符合条件的股票</div>

      <el-table
        :data="stockList"
        border
        stripe
        style="width: 100%"
        class="stock-table"
        :default-sort="{ prop: 'mfi', order: 'ascending' }"
      >
        <el-table-column prop="code" label="股票代码" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="goToKLine(scope.row.code)"
              class="code-link"
            >
              {{ scope.row.code }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="stock_name" label="股票名称" width="100"></el-table-column>
        <el-table-column prop="date" label="日期" width="100"></el-table-column>
        <el-table-column prop="close" label="收盘价" width="70" align="right">
          <template slot-scope="scope">
            {{ Number(scope.row.close).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="mfi" label="MFI" width="120" align="right">
          <template slot-scope="scope">
            <span :class="getMFIClass(scope.row.mfi)">
              {{ scope.row.mfi ? Number(scope.row.mfi).toFixed(2) : '-' }}{{ scope.row.mfi_ma5 ? '/' + Number(scope.row.mfi_ma5).toFixed(2) : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mfi_status" label="MFI状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.mfi_status)" size="small">
              {{ scope.row.mfi_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rsi" label="RSI" width="60" align="right">
          <template slot-scope="scope">
            <span :class="getRSIClass(scope.row.rsi)">
              {{ scope.row.rsi ? Number(scope.row.rsi).toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="rsi_status" label="RSI状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.rsi_status)" size="small">
              {{ scope.row.rsi_status || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="macd_dif" label="MACD" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.macd_dif ? Number(scope.row.macd_dif).toFixed(4) : '-' }}{{ scope.row.macd_dea ? '/' + Number(scope.row.macd_dea).toFixed(4) : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="macd_signal" label="MACD信号" width="90">
          <template slot-scope="scope">
            <el-tag :type="getMACDSignalType(scope.row.macd_signal)" size="small">
              {{ scope.row.macd_signal || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="kdj_k" label="KDJ" width="140" align="right">
          <template slot-scope="scope">
            {{ scope.row.kdj_k ? Number(scope.row.kdj_k).toFixed(2) : '-' }}{{ scope.row.kdj_d ? '/' + Number(scope.row.kdj_d).toFixed(2) : '' }}{{ scope.row.kdj_j ? '/' + Number(scope.row.kdj_j).toFixed(2) : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="kdj_signal" label="KDJ信号" width="80">
          <template slot-scope="scope">
            <el-tag :type="getMACDSignalType(scope.row.kdj_signal)" size="small">
              {{ scope.row.kdj_signal || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bollinger_upper" label="布林线" width="160" align="right">
          <template slot-scope="scope">
            {{ scope.row.bollinger_upper ? Number(scope.row.bollinger_upper).toFixed(2) : '-' }}{{ scope.row.bollinger_mid ? '/' + Number(scope.row.bollinger_mid).toFixed(2) : '' }}{{ scope.row.bollinger_lower ? '/' + Number(scope.row.bollinger_lower).toFixed(2) : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="bollinger_percent_b" label="%B" width="60" align="right">
          <template slot-scope="scope">
            {{ scope.row.bollinger_percent_b ? Number(scope.row.bollinger_percent_b).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="bollinger_position" label="布林位置" width="100">
          <template slot-scope="scope">
            <el-tag :type="getBollingerTagType(scope.row.bollinger_position)" size="small">
              {{ scope.row.bollinger_position || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="bollinger_band_width" label="带宽%" width="70" align="right">
          <template slot-scope="scope">
            {{ scope.row.bollinger_band_width ? Number(scope.row.bollinger_band_width).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="high_low_ratio" label="Max/Min" width="90" align="right">
          <template slot-scope="scope">
            {{ scope.row.high_low_ratio ? Number(scope.row.high_low_ratio).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="close_min_ratio" label="Cur/Min" width="90" align="right">
          <template slot-scope="scope">
            {{ scope.row.close_min_ratio ? Number(scope.row.close_min_ratio).toFixed(2) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :icon="scope.row.adding ? 'el-icon-loading' : 'el-icon-star-on'"
              @click="addToFavorite(scope.row)"
              :disabled="scope.row.adding"
            >
              {{ scope.row.added ? '已添加' : '加入自选' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 空状态 -->
    <div v-else-if="!loading && searched" class="empty-state">
      <i class="el-icon-data-analysis"></i>
      <p>未找到符合条件的股票</p>
    </div>

    <!-- 初始状态 -->
    <div v-else-if="!loading && !searched" class="empty-state">
      <i class="el-icon-data-analysis"></i>
      <p>请设置筛选条件后点击筛选按钮</p>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-state">
      <i class="el-icon-loading"></i>
      <p>正在筛选...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OversoldView',
  data() {
    return {
      mfiRange: 'oversold',
      mfiMa5Compare: '',
      rsiRange: 'oversold',
      macdSignal: '',
      kdjRange: '',
      kdjSignal: '',
      bollingerPosition: '',
      bollingerWidth: '',
      highLowRatioMin: 1.5,
      highLowRatioMax: 5,
      highLowWindow: 250,
      closeMinRatioMin: 1.1,
      closeMinRatioMax: 1.2,
      closeMinWindow: 250,
      limit: 100,
      stockList: [],
      loading: false,
      searched: false
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      this.searched = true

      try {
        const params = {
          limit: this.limit
        }

        if (this.mfiRange) {
          params.mfi_range = this.mfiRange
        }
        if (this.mfiMa5Compare) {
          params.mfi_ma5_compare = this.mfiMa5Compare
        }
        if (this.rsiRange) {
          params.rsi_range = this.rsiRange
        }
        if (this.macdSignal) {
          params.macd_signal = this.macdSignal
        }
        if (this.kdjRange) {
          params.kdj_range = this.kdjRange
        }
        if (this.kdjSignal) {
          params.kdj_signal = this.kdjSignal
        }
        if (this.bollingerPosition) {
          params.bollinger_position = this.bollingerPosition
        }
        if (this.bollingerWidth) {
          params.bollinger_width = this.bollingerWidth
        }
        if (this.highLowRatioMin !== undefined && this.highLowRatioMin !== null) {
          params.high_low_ratio_min = this.highLowRatioMin
        }
        if (this.highLowRatioMax !== undefined && this.highLowRatioMax !== null) {
          params.high_low_ratio_max = this.highLowRatioMax
        }
        if (this.highLowWindow !== undefined && this.highLowWindow !== null) {
          params.high_low_window = this.highLowWindow
        }
        if (this.closeMinRatioMin !== undefined && this.closeMinRatioMin !== null) {
          params.close_min_ratio_min = this.closeMinRatioMin
        }
        if (this.closeMinRatioMax !== undefined && this.closeMinRatioMax !== null) {
          params.close_min_ratio_max = this.closeMinRatioMax
        }
        if (this.closeMinWindow !== undefined && this.closeMinWindow !== null) {
          params.close_min_window = this.closeMinWindow
        }

        const response = await axios.get('/stock/mfi/filter', { params })

        if (response.data.status === 'success') {
          this.stockList = response.data.data || []
        } else {
          this.$message.error(response.data.message || '筛选失败')
        }
      } catch (error) {
        console.error('筛选MFI股票失败:', error)
        this.$message.error('筛选失败: ' + (error.response?.data?.message || error.message))
        this.stockList = []
      } finally {
        this.loading = false
      }
    },

    resetFilters() {
      this.mfiRange = 'oversold'
      this.mfiMa5Compare = ''
      this.rsiRange = 'oversold'
      this.macdSignal = ''
      this.kdjRange = ''
      this.kdjSignal = ''
      this.bollingerPosition = ''
      this.bollingerWidth = ''
      this.highLowRatioMin = 1.5
      this.highLowRatioMax = 5
      this.highLowWindow = 250
      this.closeMinRatioMin = 1.1
      this.closeMinRatioMax = 1.2
      this.closeMinWindow = 250
      this.limit = 100
      this.stockList = []
      this.searched = false
    },

    goToKLine(code) {
      this.$router.push({
        path: '/kline/day',
        query: { code }
      })
    },

    goToMFI(code) {
      this.$router.push({
        path: '/mfi',
        query: { code }
      })
    },

    getMFIClass(mfi) {
      if (!mfi) return ''
      if (mfi > 80) return 'mfi-overbought'
      if (mfi < 20) return 'mfi-oversold'
      return 'mfi-normal'
    },

    getRSIClass(rsi) {
      if (!rsi) return ''
      if (rsi > 70) return 'mfi-overbought'
      if (rsi < 30) return 'mfi-oversold'
      return 'mfi-normal'
    },

    getValueClass(value) {
      if (!value) return ''
      if (value > 0) return 'value-positive'
      if (value < 0) return 'value-negative'
      return 'value-neutral'
    },

    getStatusTagType(status) {
      const typeMap = {
        '超买': 'danger',
        '超卖': 'success',
        '正常': 'info'
      }
      return typeMap[status] || 'info'
    },

    getTrendTagType(trend) {
      const typeMap = {
        '上升': 'success',
        '下降': 'danger',
        '震荡': 'info'
      }
      return typeMap[trend] || 'info'
    },

    getMACDSignalType(signal) {
      const typeMap = {
        '金叉': 'success',
        '死叉': 'danger',
        '多头': 'success',
        '空头': 'danger'
      }
      return typeMap[signal] || 'info'
    },

    getBollingerTagType(position) {
      const typeMap = {
        '突破上轨': 'danger',
        '跌破下轨': 'success',
        '中轨上方': 'success',
        '中轨下方': 'info'
      }
      return typeMap[position] || 'info'
    },

    async addToFavorite(stock) {
      if (stock.adding || stock.added) return

      stock.adding = true
      try {
        await axios.post('/stock/favorite/add', {
          user_id: 'default_user',
          stock_code: stock.code,
          stock_name: stock.stock_name
        })
        stock.added = true
        this.$message.success(`已将 ${stock.stock_name}(${stock.code}) 加入自选`)
      } catch (error) {
        console.error('加入自选失败:', error)
        const msg = error.response?.data?.error || error.message || '加入自选失败'
        if (msg.includes('已在自选列表中')) {
          stock.added = true
          this.$message.info(msg)
        } else {
          this.$message.error(msg)
        }
      } finally {
        stock.adding = false
      }
    }
  }
}
</script>

<style scoped>
.mfi-oversold-view {
  padding: 24px;
  min-height: calc(100vh - 64px);
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.3);
}

.title-icon svg {
  width: 28px;
  height: 28px;
}

.page-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-decoration {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, transparent 0%, #22c55e 50%, transparent 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  letter-spacing: 0.5px;
}

.filter-bar {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  flex-wrap: wrap;
}

.filter-select {
  width: 150px;
}

.limit-input {
  width: 150px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(15, 23, 42, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #22c55e;
  min-width: 70px;
  letter-spacing: 0.5px;
}

.small-input {
  width: 100px;
}

.range-separator {
  color: #64748b;
  font-size: 14px;
  margin: 0 4px;
}

.filter-bar :deep(.el-select .el-input__inner),
.filter-bar :deep(.el-input-number .el-input__inner) {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(34, 197, 94, 0.2) !important;
  color: #e2e8f0 !important;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-select .el-input__inner):hover,
.filter-bar :deep(.el-input-number .el-input__inner):hover {
  border-color: rgba(34, 197, 94, 0.4) !important;
  box-shadow: 0 0 12px rgba(34, 197, 94, 0.15) !important;
}

.filter-bar :deep(.el-select__placeholder) {
  color: #64748b;
}

.filter-bar :deep(.el-button--primary) {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.3);
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-button--primary):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(34, 197, 94, 0.45);
}

.result-section {
  margin-bottom: 24px;
}

.result-count {
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 14px;
  padding: 12px 24px;
  background: rgba(34, 197, 94, 0.08);
  border-radius: 8px;
  border-left: 3px solid #22c55e;
  display: inline-block;
}

.result-count strong {
  color: #22c55e;
  font-weight: 600;
  font-size: 16px;
}

.stock-table {
  background: rgba(30, 41, 59, 0.3);
  border-radius: 16px;
  overflow: hidden;
}

.stock-table :deep(.el-table__header-wrapper) {
  background: rgba(15, 23, 42, 0.8);
}

.stock-table :deep(th.el-table__cell) {
  background: rgba(15, 23, 42, 0.8) !important;
  color: #a5b4fc;
  font-weight: 600;
  border-bottom: 1px solid rgba(34, 197, 94, 0.2);
}

.stock-table :deep(td.el-table__cell) {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.stock-table :deep(.el-table__row) {
  background: rgba(30, 41, 59, 0.3);
  transition: all 0.25s ease;
}

.stock-table :deep(.el-table__row:hover td) {
  background: rgba(34, 197, 94, 0.1) !important;
}

.stock-table :deep(.el-button--text) {
  color: #a5b4fc;
  transition: all 0.2s ease;
}

.stock-table :deep(.el-button--text:hover) {
  color: #c7d2fe;
  text-shadow: 0 0 8px rgba(165, 180, 252, 0.4);
}

.code-link {
  color: #a5b4fc;
  font-weight: 500;
  padding: 0;
}

.code-link:hover {
  color: #22c55e;
}

/* 数值样式 */
.value-positive {
  color: #22c55e;
  font-weight: 600;
}

.value-negative {
  color: #ef4444;
  font-weight: 600;
}

.value-neutral {
  color: #94a3b8;
}

/* MFI样式 */
.mfi-overbought {
  color: #ef4444;
  font-weight: 600;
}

.mfi-oversold {
  color: #22c55e;
  font-weight: 600;
}

.mfi-normal {
  color: #94a3b8;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 120px 24px;
  color: #64748b;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 16px;
  display: block;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

.loading-state {
  text-align: center;
  padding: 100px 24px;
}
</style>
